// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import style from './FreqQuestions.scss';
import icons from '../../assets/styles/icons.scss';

export type Question = {
  labelIntl: string;
  contentIntl: string;
};

type Props = {
  +titleIntl: string;
  +questions: Question[];
  +customClassName?: string;
  +textOpenClassName?: string;
};

type State = {
  questionsOpen: boolean[];
};

export default class FreqQuestions extends Component<Props, State> {
  state = {
    questionsOpen: [],
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      questionsOpen: this.generateFalseState(props.questions),
    };
  }

  generateFalseState = (questions: Question[]): boolean[] => questions.map(_ => false);


  handleClickOpen(index: number) {
    const { questions } = this.props;
    this.setState((state: State) => {
      const questionsOpen = this.generateFalseState(questions);
      questionsOpen[index] = !state.questionsOpen[index];
      return {
        questionsOpen,
      };
    });
  }

  render() {
    const { titleIntl, questions, customClassName, textOpenClassName } = this.props;
    const { questionsOpen } = this.state;
    const questionsContent = questions.map((q: Question, n: number) => (
      <li key={n}>
        <FormattedMessage id={q.labelIntl}>{
          txt => <h5 className={style.title}
                     onClick={_ => this.handleClickOpen(n)}>{txt}
            <i className={classNames(style.caret,
              { [icons.iconMinusLight]: questionsOpen[n] },
              { [icons.iconPlusLight]: !questionsOpen[n] })}/>
          </h5>
        }</FormattedMessage>
        <FormattedMessage id={q.contentIntl}>{
          txt => <p className={classNames(style.content,
            { [style.open]: !(!!textOpenClassName) && questionsOpen[n] },
            { [(textOpenClassName: any)]: !!textOpenClassName && questionsOpen[n] })}>{txt}</p>
        }</FormattedMessage>
      </li>
    ));
    return (
      <section className={classNames(style.freqQuestionsWrap, customClassName)}>
        <FormattedMessage id={titleIntl}>{
          txt => <h4 className={style.title}>{txt}</h4>
        }</FormattedMessage>
        <ul>
          {questionsContent}
        </ul>
      </section>
    );
  }
}

FreqQuestions.propTypes = {
  titleIntl: PropTypes.string.isRequired,
  questions: PropTypes.array.isRequired,
  customClassName: PropTypes.string,
  textOpenClassName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/elements/FreqQuestions/FreqQuestions.jsx